function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#464a55",
  d: "M21.516 7.628l-.382.382-3.598-3.599.382-.382a2.556 2.556 0 0 1 3.598 0 2.556 2.556 0 0 1 0 3.599zM7.601 21.543l-3.598-3.598L15.72 6.227l3.598 3.598zm-5.159 1.401l.064-2.897 2.961 2.961zm13.661-20.73L.627 17.722c-.414.414-.637.923-.637 1.497l-.095 4.012c0 .573.19 1.146.605 1.56.414.414.955.669 1.528.669l4.204.095h.031c.574 0 1.147-.222 1.56-.636L23.3 9.443c1.974-1.975 1.974-5.223 0-7.197C21.325.24 18.11.24 16.103 2.214z"
})));

var SvgEditPostIcon = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditPostIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-post-icon.cc88242c.svg";
export { ForwardRef as ReactComponent };